import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';

interface StepLink {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface Props {
  title: string;
  description: React.ReactNode;
  /** Shown beside the title, such as an edit button. */
  actions?: React.ReactNode;
  back?: StepLink;
  next?: StepLink;
  children: React.ReactNode;
}

/** The same frame for every builder step: what it's for, its content, then the way on. */
export default function BuilderStepLayout({ title, description, actions, back, next, children }: Props) {
  return (
    <Stack spacing={3}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="space-between">
        <Box>
          <Typography variant="h5">{title}</Typography>
          <Typography color="text.secondary" mt={0.5}>
            {description}
          </Typography>
        </Box>
        {actions && <Box flexShrink={0}>{actions}</Box>}
      </Stack>

      {children}

      {(back || next) && (
        <>
          <Divider />
          <Stack direction="row" justifyContent="space-between">
            <Box>
              {back && (
                <Button startIcon={<ArrowBackIcon />} onClick={back.onClick} disabled={back.disabled}>
                  {back.label}
                </Button>
              )}
            </Box>
            {next && (
              <Button
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                onClick={next.onClick}
                disabled={next.disabled}
              >
                {next.label}
              </Button>
            )}
          </Stack>
        </>
      )}
    </Stack>
  );
}
